// @flow

import { takeLatest, call, put } from 'redux-saga/effects';
import type { IOEffect } from 'redux-saga/effects';

import ActionTypes from './action-types';

import getDurationProfileApi from './apis';

export type DurationProfile = {
  as_planned: number,
  extended: number,
  shortened: number,
  end_date: string,
  project_id: number,
  start_date: string,
};

export type DurationProfileSuccessType = {
  profiles: DurationProfile[],
};

export type ActivityProfileAction = {|
  type: typeof ActionTypes.GET_WEEKLY_DURATION_PROFILE_SUCCESS,
  data: DurationProfileSuccessType,
|} | {|
  type: typeof ActionTypes.GET_WEEKLY_DURATION_PROFILE_FAIL,
|};

function* getDurationProfile(action: { data: { projectId: string } }): Generator<IOEffect, void, any> {
  try {
    const response: { data: DurationProfileSuccessType } = yield call(getDurationProfileApi, action.data.projectId);
    const actionData: ActivityProfileAction = { type: ActionTypes.GET_WEEKLY_DURATION_PROFILE_SUCCESS, data: response.data };
    yield put(actionData);
  } catch (e) {
    const actionData: ActivityProfileAction = { type: ActionTypes.GET_WEEKLY_DURATION_PROFILE_FAIL };
    yield put(actionData);
  }
}

export default function* root(): Generator<IOEffect, void, any> {
  yield takeLatest(ActionTypes.GET_WEEKLY_DURATION_PROFILE, getDurationProfile);
}
